module.exports = global["jQuery"] = require("-!/builds/Spartans/nassfeld-2019/node_modules/expose-loader/index.js?$!./jquery.js");